import { useLayoutEffect, useRef } from "react";

export const ScrollBarAdapter = ({}) => {
    const myref = useRef();

    function onResize() {
        try {
          var evt = new UIEvent('resize');
          window.dispatchEvent(evt);
        } catch(e) {}
    }

    useLayoutEffect(() => {
        myref.current.contentWindow.addEventListener("resize", onResize, false);
        return () => myref.current.contentWindow.removeEventListener("resize", onResize, false);
    }, []);

    let styles = {
        height: 0,
        margin: 0,
        padding: 0,
        overflow: "hidden",
        borderWidth: 0,
        position: "absolute",
        backgroundColor: "transparent",
        width: "100%"
    };

    return (
        <iframe ref={myref} style={styles} />
    )
};
